import React, { useState } from "react";

import { Modal } from "@material-ui/core";
import Login from "../../pages/Login";
import SignUp from "../../pages/SignUp";

export default function LogInModal(props) {
  const [content, setContent] = useState("login");
  return (
    <div>
      <Modal
        open={props.open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        {content === "login" ? (
          <Login
            closeModal={props.closeModal}
            loadSignUp={() => setContent("signup")}
          />
        ) : (
          <SignUp
            closeModal={props.closeModal}
            loadLogin={() => setContent("login")}
          />
        )}
      </Modal>
    </div>
  );
}
